import React from "react";
import Page from "../common/page/Page.js";
import useTranslationFooter from "./useTranslationFooter.js";
import ContactUsForm from "./ContactUsForm.js";

export default function ContactUsPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationFooter();

  return (
    <Page>
      <Page.Title loading={tLoading}>
        {t("footer:footer_contact_us_title")}
      </Page.Title>
      <Page.Content>
        <ContactUsForm />
      </Page.Content>
    </Page>
  );
}
